import { ApolloProvider } from '@apollo/client';

const withApolloProvider = (Component: any) => {
  const Provider = (props: any) => {
    // Dynamically import client and mockClient here
    const { client } = require('./client');

    return (
      <ApolloProvider client={client}>
        <Component {...props} />
      </ApolloProvider>
    );
  };

  Provider.displayName = `withApolloProvider(${Component.displayName ?? Component.name ?? 'Component'})`;
  return Provider;
};

export default withApolloProvider;
